// extracted by mini-css-extract-plugin
export default {"about":"About_about__xDXzD","linkbutton":"About_linkbutton__xTFMt"};